import { useState, useEffect } from "react"
import GetImvImages from "../../services/GetImages"
import { Carousel } from "react-responsive-carousel"
import LoadingWheel from "../assets/LoadingWheel"
import ImagesNotFound from "../assets/_ImagesNotFound"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { supabase } from "../../services/storageClient"
import { useQuery } from "react-query"

export default function ImvCarousel({ nreg, modal = false }) {
    // const images = GetImvImages({nreg})
    const [urlList, setUrlList] = useState(null)
    const [activeImage, setActiveImage] = useState(undefined)

    const { data, isLoading, error } = useQuery('images', async () => {
        try {
            const listData = await supabase.storage.from('imv_images').list(`${nreg}`);
            //   console.log('data: ', listData);

            const _urlList = await Promise.all(listData.data.map((image) => {
                // console.log("image: ", image.name)
                return supabase.storage.from('imv_images').getPublicUrl(`${nreg}/` + image.name);
            }));

            //   console.log('Images Url: ', _urlList)
            return _urlList; // Return the array of public URLs
        } catch (error) {
            console.error('Error fetching images:', error);
            throw error; // Re-throw the error for useQuery to handle
        }
    });

    // useEffect(() => {
    //     console.log('images Data: ', data)
    // }, [data])


    return (
        <>
            {data ? (
                <Carousel
                    showThumbs={false}
                    labels={false}
                    showIndicators={false}
                    showStatus={false}
                    className="min-h-full xl:h-[40rem] max-xl:h-[25rem] w-full rounded-l-lg object-scale-down backdrop-blur-xl [&>img]:object-scale-"
                >
                    {data.map((image, index) => (
                        <img
                            src={image.data.publicUrl}
                            alt={`Imagem ${index + 1}`}
                            className={`rounded-xl xl:h-[44rem] w-full bg-[#0003] object-scale-down
                            ${modal ? ' xl:rounded-l-xl min-h-full max-xl:h-[25rem] max-[1280px]:rounded-t-xl object-scale-down'
                                    : 'cover aspect-video'
                                }`}
                        />
                    ))}
                </Carousel>
            ) : (
                <section className="bg-[#0009] h-full w-full flex items-center justify-center rounded-l-xl">
                    <ImagesNotFound />
                </section>)}
        </>
    );
}

const ImvThumb = ({ nreg }) => {
    const getThumb = async () => {
        const { data, error } = await supabase.storage.from('imv_images').list(`${nreg}`)

        if (!data[0]) {
            return false

        } else {
            const response = supabase.storage
                .from('imv_images')
                .getPublicUrl(`${nreg}/${data[0].name}`)

            return response.data.publicUrl
        }

    }

    const NotFound = () => {
        return (
            <ImagesNotFound />
        )
    }

    const [thumb, setThumb] = useState(undefined)

    useEffect(() => {
        const fetchThumb = async () => {
            const thumbUrl = await getThumb();
            setThumb(thumbUrl);
        };

        fetchThumb();
    }, [nreg]);


    return (<>
        {thumb ? (<img className="w-full h-full border-none rounded-xl object-cover" src={thumb} alt="" />) : <NotFound />}
    </>)
}

export { ImvThumb }

{/* <Carousel showThumbs={false} labels={false} showIndicators={false} showStatus={false} className="">
            {images.length > 0 ? images.map((image) => (
                <div 
                    className={`min-h-full ${modal ? 'flex items-center object-contain backdrop-blur-2xl rounded-xl' : 'aspect-video'}`}>
                    <img src={image.data.publicUrl} alt="" className={`min-h-full rounded-xl ${modal ? 'object-none rounded-xl' : 'aspect-video object-cover'}`} />
                </div>
            )) : 
                <ImagesNotFound />
            }
        </Carousel> */}